export default "__VITE_PUBLIC_ASSET__26fb3b19__"